var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotovoltaicPlanned({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7579)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFE359"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4208 16.6689C23.625 16.6822 23.824 16.7428 24.0018 16.8457C24.2051 16.9633 24.3742 17.1323 24.4911 17.3359C24.6079 17.5394 24.6677 17.7703 24.6669 18.0049C24.6659 18.237 24.6042 18.465 24.4882 18.666L24.4892 18.667L23.6972 20.0547L24.621 22.4248C24.7544 22.7678 24.5841 23.1545 24.2411 23.2881C23.8982 23.4213 23.5115 23.2519 23.3778 22.9092L22.8466 21.5459L22.4198 22.2949L22.4208 22.2959C22.2484 22.61 21.9947 22.8722 21.6864 23.0547C21.4164 23.2145 21.1125 23.3083 20.8007 23.3291L20.6669 23.333H12.6669L12.4921 23.3213C12.3187 23.2985 12.1512 23.2415 11.9989 23.1533C11.7957 23.0356 11.6264 22.8668 11.5097 22.6631C11.393 22.4594 11.3318 22.2279 11.3329 21.9932C11.3341 21.7613 11.3966 21.5337 11.5126 21.333L13.5849 17.6963C13.7569 17.3862 14.0082 17.1272 14.3134 16.9463C14.6219 16.7635 14.9743 16.6671 15.3329 16.667H23.3329L23.4208 16.6689ZM12.6708 21.9932L12.6669 22H16.0927L16.8524 20.667H13.4267L12.6708 21.9932ZM17.6278 22H20.6669C20.7862 22 20.904 21.9679 21.0067 21.9072C21.1094 21.8464 21.1944 21.7589 21.2518 21.6543L21.2567 21.6445L21.8143 20.667H18.3866L17.6278 22ZM15.3329 18C15.2135 18.0001 15.0958 18.0319 14.9931 18.0928C14.8903 18.1537 14.8063 18.2419 14.7489 18.3467C14.7472 18.3499 14.7449 18.3532 14.7431 18.3564L14.1864 19.333H17.6122L18.372 18H15.3329ZM19.1474 19.333H22.5751L23.3309 18.0068L23.3339 18H19.9061L19.1474 19.333ZM11.9999 14C12.3681 14 12.6669 14.2988 12.6669 14.667V16C12.6669 16.3682 12.3681 16.667 11.9999 16.667C11.6317 16.6669 11.3329 16.3682 11.3329 16V14.667C11.3329 14.2988 11.6317 14.0001 11.9999 14ZM15.3017 12.6357C15.562 12.3754 15.9847 12.3754 16.245 12.6357L17.1845 13.5752C17.4447 13.8356 17.4448 14.2582 17.1845 14.5186C16.9242 14.7784 16.5023 14.7784 16.2421 14.5186L15.3017 13.5781C15.0415 13.3179 15.0417 12.8961 15.3017 12.6357ZM14.6669 8.66699C15.0349 8.66712 15.3327 8.96504 15.3329 9.33301C15.3329 10.2171 14.9815 11.0653 14.3563 11.6904C13.7313 12.3153 12.8838 12.667 11.9999 12.667C11.6317 12.6669 11.3329 12.3682 11.3329 12C11.3329 11.6318 11.6317 11.3331 11.9999 11.333C12.5303 11.333 13.0389 11.1221 13.414 10.7471C13.789 10.372 13.9999 9.86339 13.9999 9.33301C14.0001 8.96497 14.2988 8.66699 14.6669 8.66699ZM18.6669 8.66699C19.0349 8.66712 19.3327 8.96504 19.3329 9.33301C19.3329 9.70112 19.035 9.99988 18.6669 10H17.3329C16.9649 9.99977 16.6669 9.70106 16.6669 9.33301C16.6671 8.96511 16.965 8.66722 17.3329 8.66699H18.6669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7579",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7579",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotovoltaicPlanned);
export default __webpack_public_path__ + "static/media/photovoltaic_planned.ba9023ee2f8e98145bc96186f21df020.svg";
export { ForwardRef as ReactComponent };